var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text',{staticClass:"text-left"},[_c('input',{ref:"inputFile",staticClass:"text-left",staticStyle:{"background-color":"rgba(0, 0, 0, 0.1)"},attrs:{"type":"file"},on:{"change":_vm.handleFileChange}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }